import EChartsController from "../echarts_controller"

export default class extends EChartsController {
  static values = {
    data: { type: Array, default: [] },
  }

  chartTargetConnected(target) {
    super.chartTargetConnected(target)
    this.renderChart(this.chart, this.dataValue)
  }

  renderChart(chart, collection) {
    chart.setOption({
      tooltip: {
        trigger: "item",
        confine: true,
      },
      title: {
        left: "center",
        top: "center",
        itemGap: -1,
        textStyle: {
          color: "#fff",
          fontSize: 20,
          lineHeight: 20,
          fontWeight: "bold",
        },
        subtextStyle: {
          color: "#B6C7D8",
          fontSize: 13,
        },
      },
      series: [
        {
          type: "pie",
          radius: ["30%", "70%"],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 0,
            borderColor: "#0D1926",
            borderWidth: 2,
          },
          label: {
            show: false,
          },
          emphasis: {
            label: {
              show: false,
            },
          },
          labelLine: {
            show: false,
          },
          data: collection.map(({ name, count }) => {
            return {
              name,
              value: count,
            }
          }),
        },
      ],
    })
  }
}
